import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ThreeColumnRadioCard from './three_column_radio_card';


class SelectClassModal extends Component {
  constructor(props) {
    super(props);
    this.state={
        rerender: false,
        waitState: false,
        submitButton: false,
    }    
    this.selectedAccountNbr = this.props.accountNbr;
}

saveSelect(accountSelected){
    this.selectedAccountNbr = accountSelected;
    if (this.selectedAccountNbr !== this.props.accountNbr){
        this.setState({submitButton: true});
    }else{
        this.setState({submitButton: false});
    }
}

render() {
    const infoType = "label-label-label";
    this.accountSelectList = this.props.accountList.map((accountList, key) =>
        <ThreeColumnRadioCard key={key} outInfo={accountList} 
            infoType={infoType}  
            currentAccountNbr={this.props.accountNbr}
            selectedAccountNbr={this.selectedAccountNbr}
            onSelect={(event) => this.saveSelect(event)} />
        )
    
return <>
    <Modal className="text-center" show={this.props.show}  onHide={() => this.props.onClose()} 
       size="med" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>Select a Class From the List Below</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
            <table className="table table-borderless table-sm">
                <tbody>
                    <tr className = "vertical-center">
                        <th></th>
                        <th className="">Class Code</th>
                        <th className="">Name of the Class</th>
                        <th className="">Date Assigned</th>
                    </tr>
                    {this.accountSelectList}
                </tbody>
            </table>
            <div className="font-weight-bold mb-2">
                The class that is currently selected is highlighted above.
            </div>
        </Modal.Body> 
        <Modal.Footer className="backgroundTopBottom">
            {this.state.submitButton  ?
                <Button className="ml-4" variant="secondary"  
                    onClick={() => this.props.changeClassCode(this.selectedAccountNbr)}>
                    Change Class
                </Button>
            :
                null
             }
                <Button className="ml-4" variant="secondary"  onClick={() => this.props.onClose()}>
                    Close
                </Button>
                             
        </Modal.Footer>
       
    </Modal>
    
  </>
}



}
export default SelectClassModal;